import React from 'react';
import { NavLink } from 'react-router-dom';
const CardStep5 = ({ setCurrentStep }) => {
   return (
      <div className="modal_content_body text-center">
         <h3 className="ppt_form_title mb-4 text-center">Credit / Debit card payment</h3>
         <div className='ppt_deposit_item'>
            <img
               src={process.env.PUBLIC_URL + '/assets/img/icon_failed.svg'}
               alt=""
               style={{ width: '100px' }}
               className="d-block mb-2 mx-auto"
            />
            <p className="col-lg-10 mx-lg-auto mb-2">
               <strong className='d-block'>Payment failed!</strong>
               Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.
            </p>
            <button
               className="ppt_btn_primary alt"
               onClick={() => setCurrentStep(1)}
            >
               Return to buy
            </button>
            <div className="d-flex justify-content-center gap-3 pt-2">
               <small><strong>For any inquiry on your order's status please contact sales at <NavLink className='t-anchor' to='tel:+18242585211'><u>+1 824 258 5211</u></NavLink> or use the <NavLink className='t-anchor' to=''><u>chat bot</u></NavLink>.</strong></small>
            </div>
         </div>
      </div>
   );
};
export default CardStep5